import create from "zustand";
import * as THREE from "three";
import { devtools } from "zustand/middleware";
import { socket } from "./component/soket";
import * as audio from "./audio";

const checkPoint = [1, 18, 35, 52, 69, 86, 103];

const useStore = create(
    devtools((set, get) => ({
        lang: localStorage.getItem("lang") ? localStorage.getItem("lang") : "ru",
        startMove: false,
        soon: null,
        gameOver: false,
        lastCell: false,
        i: 0,
        pointActive: 0,
        meteorits: [],
        station: 0,
        dice: 0,
        sound: localStorage.getItem("tankionline-new-year-sound")
            ? JSON.parse(localStorage.getItem("tankionline-new-year-sound"))
            : false,
        readInfo: localStorage.getItem("tankionline-new-year-read-info")
            ? JSON.parse(localStorage.getItem("tankionline-new-year-read-info"))
            : false,
        move: 0,
        temp: [],
        give_prize: [],
        action: false,
        modalStore: false,
        loggedIn: false,
        username: "",
        token: "",
        energy: 0,
        modalErrorShow: false,
        errorType: "",
        locator: false,
        flymode: false,
        infoStation: false,
        crystal: 0,
        repair: 0,
        protection: 0,
        damage: 0,
        boost: 0,
        common_key: 0,
        rare_key: 0,
        epic_key: 0,
        grenade: 0,
        snowball: 0,
        king: 0,
        firework: 0,
        nuclear_power: 0,
        check_crystall: 0,
        check_tankoin: 0,
        modalSuperPrize: false,
        point_one: 0,
        point_two: 0,
        point_three: 0,
        point_four: 0,
        point_five: 0,
        point_six: 0,
        point_seven: 0,
        frameTime: window.innerWidth < 900 ? 0.016 : 0.007,
        setFrameTime: (time) => {
            set({
                frameTime: time
            })
        },
        setFlyMode: () => {
            set({
                flymode: true
            })
        },
        getUser: async (data) => {
            const summ_prize_pre = data.give_prize ? data.give_prize : 0;
            const summ_prize = summ_prize_pre ? calculateSum(data.give_prize) : 0;
            set({
                username: data.username,
                token: data.token,
                loggedIn: true,
                gameOver: data.endgame,
            });
            localStorageSave(data.username, data.token);
            set({
                i: data.cell ? data.cell : 0,
                circle: Math.floor(data.cell / 22),
                station: data.cell ? data.cell : 0,
                energy: data.currentEnergy ? data.currentEnergy : 0,
                move: data.step ? data.step : 0,
                give_prize: data.give_prize ? data.give_prize : [],
            });
            set((state) => ({
                repair: data.repair ? data.repair - summ_prize.repair : 0,
                protection: data.protection
                    ? data.protection - summ_prize.protection
                    : 0,
                damage: data.damage ? data.damage - summ_prize.damage : 0,
                boost: data.boost ? data.boost - summ_prize.boost : 0,
                crystal: data.crystal ? data.crystal - summ_prize.crystal : 0,
                common_key: data.common_key ? data.common_key - summ_prize.common_key : 0,
                epic_key: data.epic_key ? data.epic_key - summ_prize.epic_key : 0,
                rare_key: data.rare_key ? data.rare_key - summ_prize.rare_key : 0,
                grenade: data.grenade ? data.grenade - summ_prize.grenade : 0,
                snowball: data.snowball ? data.snowball - summ_prize.snowball : 0,
                king: data.king ? data.king - summ_prize.king : 0,
                firework: data.firework ? data.firework - summ_prize.firework : 0,
                nuclear_power: data.nuclear_power
                    ? data.nuclear_power - summ_prize.nuclear_power
                    : 0,
                paint: data.paint ? data.paint : 0,
                check_crystall: data.crystal ? data.crystal : 0,
                check_tankoin: data.tankoin ? data.tankoin : 0,
                meteorits: data.meteorits,
            }));
        },
        initGame: async (data) => {
            const summ_prize_pre = data.give_prize ? data.give_prize : 0;
            const summ_prize = summ_prize_pre ? calculateSum(data.give_prize) : 0;
            set({
                username: data.username,
                i: data.cell ? data.cell : 0,
                lastCell: data.cell === 103,
                summ_prize: summ_prize,
                circle: Math.floor(data.cell / 22),
                station: data.cell ? data.cell : 0,
                energy: data.currentEnergy ? data.currentEnergy : 0,
                move: data.step ? data.step : 0,
                give_prize: data.give_prize ? data.give_prize : [],
            });
            set((state) => ({
                repair: data.repair ? data.repair - summ_prize.repair : 0,
                protection: data.protection
                    ? data.protection - summ_prize.protection
                    : 0,
                damage: data.damage ? data.damage - summ_prize.damage : 0,
                boost: data.boost ? data.boost - summ_prize.boost : 0,
                crystal: data.crystal ? data.crystal - summ_prize.crystal : 0,
                common_key: data.common_key ? data.common_key - summ_prize.common_key : 0,
                rare_key: data.rare_key ? data.rare_key - summ_prize.rare_key : 0,
                epic_key: data.epic_key ? data.epic_key - summ_prize.epic_key : 0,
                grenade: data.grenade ? data.grenade - summ_prize.grenade : 0,
                snowball: data.snowball ? data.snowball - summ_prize.snowball : 0,
                king: data.king ? data.king - summ_prize.king : 0,
                firework: data.firework ? data.firework - summ_prize.firework : 0,
                nuclear_power: data.nuclear_power
                    ? data.nuclear_power - summ_prize.nuclear_power
                    : 0,
                check_crystall: data.crystal ? data.crystal : 0,
                check_tankoin: data.tankoin ? data.tankoin : 0,
                meteorits: data.meteorits,
            }));
        },

        new_Step: () => {
            if (!get().action && get().i < 103) {
                set((state) => ({
                    action: true,
                }));
                getUserScore();
            }
        },
        soundClick: () => {
            localStorage.setItem("tankionline-new-year-sound", !get().sound);
            set((state) => ({
                sound: !state.sound,
            }));
        },
        setReadInfo: () => {
            localStorage.setItem("tankionline-new-year-read-info", !get().readInfo);
            set((state) => ({
                readInfo: !state.readInfo,
            }));
        },
        showSoon: (data) => {
            set((state) => ({
                soon: data,
            }));
        },
        modalError: (data) => {
            set((state) => ({
                modalErrorShow: true,
                errorType: data,
            }));
        },
        modalEndGame: async (data) => {
            const summ_prize = data.give_prize ? calculateSum(data.give_prize) : 0;
            set((state) => ({
                gameOver: true,
                modalEndGameShow: true,
                sumEndGame: summ_prize,
            }));
        },
        closemodalError: () =>
            set((state) => ({
                action: false,
                locator: false,
                modalErrorShow: false,
            })),
        launch_nextlevel: async (data) => {
            const summ_prize = data.give_prize ? calculateSum(data.give_prize) : 0;
            set((state) => ({
                energy: data.currentEnergy ? data.currentEnergy : 0,
                temp: data,
            }));
            const rollValue = await Move_Between(data.steps[0], get().i);
            set((state) => ({
                move: data.step,
                i: data.steps[0],
                wayPoint: data.steps,
                dice: rollValue,
                pointActive: data.steps[0],
            }));
            set((state) => ({
                summ_prize: summ_prize,

                found_repair: data.repair - (state.repair + summ_prize.repair),
                found_protection: data.protection - (state.protection + summ_prize.protection),
                found_damage: data.damage - (state.damage + summ_prize.damage),
                found_boost: data.boost - (state.boost + summ_prize.boost),

                found_common_key: data.common_key - (state.common_key + summ_prize.common_key),
                found_rare_key: data.rare_key - (state.rare_key + summ_prize.rare_key),
                found_epic_key: data.epic_key - (state.epic_key + summ_prize.epic_key),
                found_grenade: data.grenade - (state.grenade + summ_prize.grenade),
                found_snowball: data.snowball - (state.snowball + summ_prize.snowball),
                found_king: data.king - (state.king + summ_prize.king),
                found_firework: data.firework - (state.firework + summ_prize.firework),
                found_crystal: data.crystal - (state.crystal + summ_prize.crystal),
                found_nuclear_power:
                    data.nuclear_power - (state.nuclear_power + summ_prize.nuclear_power),
                give_prize: data.give_prize ? data.give_prize : [],
                last_prize_crystall: summ_prize.crystal - state.check_crystall,

                last_prize_repair: summ_prize.repair - state.check_repair,
                last_prize_protection: summ_prize.protection - state.check_protection,
                last_prize_damage: summ_prize.damage - state.check_damage,
                last_prize_boost: summ_prize.boost - state.check_boost,

                last_prize_common_key: summ_prize.common_key - state.check_common_key,
                last_prize_rare_key: summ_prize.rare_key - state.check_rare_key,
                last_prize_epic_key: summ_prize.epic_key - state.check_epic_key,
                last_prize_grenade: summ_prize.grenade - state.check_grenade,
                last_prize_snowball: summ_prize.snowball - state.check_snowball,
                last_prize_king: summ_prize.king - state.check_king,
                last_prize_firework: summ_prize.firework - state.check_firework,

                check_crystall: data.crystal ? data.crystal : 0,

                check_repair: data.repair ? data.repair : 0,
                check_protection: data.protection ? data.protection : 0,
                check_damage: data.damage ? data.damage : 0,
                check_boost: data.boost ? data.boost : 0,

                check_common_key: data.common_key ? data.common_key : 0,
                check_rare_key: data.rare_key ? data.rare_key : 0,
                check_epic_key: data.epic_key ? data.epic_key : 0,
                check_grenade: data.grenade ? data.grenade : 0,
                check_snowball: data.snowball ? data.snowball : 0,
                check_king: data.king ? data.king : 0,
                check_firework: data.firework ? data.firework : 0,

                meteorits: data.meteorits,
            }));

            set((state) => ({
                locator: true,
                station: state.i,

                startMove: true,
            }));
        },
        modal_showStore: () => {
            set((state) => ({
                modalStore: !state.modalStore,
            }));
        },
        closeinfoModalStation: async () => {
            set((state) => ({
                action: false,
                locator: false,
                infoStation: false,

                repair: state.temp.repair - state.summ_prize.repair,
                protection: state.temp.protection - state.summ_prize.protection,
                damage: state.temp.damage - state.summ_prize.damage,
                boost: state.temp.boost - state.summ_prize.boost,
                crystal: state.temp.crystal - state.summ_prize.crystal,

                common_key: state.temp.common_key - state.summ_prize.common_key,
                rare_key: state.temp.rare_key - state.summ_prize.rare_key,
                epic_key: state.temp.epic_key - state.summ_prize.epic_key,
                grenade: state.temp.grenade - state.summ_prize.grenade,
                snowball: state.temp.snowball - state.summ_prize.snowball,
                king: state.temp.king - state.summ_prize.king,
                firework: state.temp.firework - state.summ_prize.firework,

                nuclear_power:
                    state.temp.nuclear_power - state.summ_prize.nuclear_power,
                modalSuperPrize: false,
                lastCell: get().i === 103,
            }));
            if (get().temp.steps.length > 1) {
                const rollValue = await Move_Between(
                    get().temp.steps[1],
                    get().temp.steps[0]
                );
                const tmp = get().temp;
                const tempStepsArray = [tmp.steps[1]]
                tmp.steps[2] && tempStepsArray.push(tmp.steps[2])
                tmp.steps = tempStepsArray;
                set((state) => ({
                    temp: tmp,
                }));
                set((state) => ({
                    i: get().temp.steps[0],
                    startMove: true,
                    station: get().temp.steps[0],
                    locator: true,
                    dice: rollValue,
                }));
            }
        },
        setLang: async (data) => {
            set({
                lang: data,
            });
        },
        locatorDisable: () => {
            set({
                locator: false,
            });
        },
        stopMove: async () => {
            set((state) => ({
                startMove: false,
                infoStation: false,
            }));
            set((state) => ({
                action: false,

                repair: state.temp.repair - state.summ_prize.repair,
                protection: state.temp.protection - state.summ_prize.protection,
                damage: state.temp.damage - state.summ_prize.damage,
                boost: state.temp.boost - state.summ_prize.boost,
                crystal: state.temp.crystal - state.summ_prize.crystal,

                common_key: state.temp.common_key - state.summ_prize.common_key,
                rare_key: state.temp.rare_key - state.summ_prize.rare_key,
                epic_key: state.temp.epic_key - state.summ_prize.epic_key,
                grenade: state.temp.grenade - state.summ_prize.grenade,
                snowball: state.temp.snowball - state.summ_prize.snowball,
                king: state.temp.king - state.summ_prize.king,
                firework: state.temp.firework - state.summ_prize.firework,

                nuclear_power:
                    state.temp.nuclear_power - state.summ_prize.nuclear_power,
                paint: state.temp.paint,
                modalSuperPrize:
                    checkPoint.lastIndexOf(get().i) !== -1 && get().dice > 0,
            }));
            if (get().temp.steps.length > 1) {
                const rollValue = await Move_Between(
                    get().temp.steps[1],
                    get().temp.steps[0]
                );
                set((state) => ({
                    dice: rollValue,
                    infoStation: true,
                }));
            }
        },
    }))
);

function getUserScore(token) {
    const sendData = {
        token: localStorage.getItem("token"),
    };
    socket.emit("step", sendData);
}

function localStorageSave(username, token) {
    localStorage.setItem("username", username);
    localStorage.setItem("token", token);
}

function Move_Between(newest, older) {
    return new Promise((resolve, reject) => {
        const between = newest - older;
        resolve(between);
    });
}

function calculateSum(data) {
    let newData = {
        crystal: 0,
        repair: 0,
        protection: 0,
        damage: 0,
        boost: 0,
        point_five: 0,
        point_six: 0,
        point_seven: 0,
        point_four: 0,
        point_one: 0,
        point_three: 0,
        point_two: 0,
        common_key: 0,
        rare_key: 0,
        epic_key: 0,
        grenade: 0,
        snowball: 0,
        king: 0,
        firework: 0,
    };
    for (let i = 0; i <= data.length; i++) {
        for (let key in data[i]) {
            newData[key] += data[i][key];
        }
    }
    return newData;
}

function playAudio(audio, volume = 1, loop = false) {
    audio.volume = volume
    audio.loop = loop
    if (!audio.paused) return
    audio.play()
    if (loop) {
        audio.addEventListener('timeupdate', () => {
            if (audio.currentTime >= 59.5) {
                audio.currentTime = 0.5;
            }
            if (audio.currentTime <= 0.49) audio.currentTime = 0.5;
        })
    }
}

export default useStore;
export { audio, playAudio };
